import React, { useEffect, useRef, useState } from "react";
import "./login.css";
import subLogo from "../../../assets/subBgLogo.png";
import asscentsLogo from "../../../assets/Loginlogo.png";
import eyeOn from "../../../assets/eye-on.svg";
import eyeOff from "../../../assets/eye-off.svg";
import eyeDead from "../../../assets/eyedead.svg";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ErrorMsg from "../../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/actions/authActions";
import { Spinner } from "react-bootstrap";
import ErrorPopup from "../../../components/Popups/ErrorPopup";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef();
  const [disable, setDisable] = useState(true);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState('');
  const [passwordVisible, setPasswordVisible] = useState();
  const [passwordDisable, setPasswordDisable] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };

  const loginSchema = Yup.object().shape({
    email: Yup.string().email().required("Required"),
    password: Yup.string().required("Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    setSubmitDisable(true);
    dispatch(login(values.email, values.password, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    setSubmitDisable(false);
    if (data.data.data.distributorData.email_verified == true) {
      if (data.data.data.distributorData.is_new == true) {
        navigate("/create-new-password", { state: data.data.access_token });
      }
      else if (data.data.data.distributorData.is_details == false) {
        navigate("/register-distribution-details");
      } else if (data.data.data.distributorData.is_contact_details == false) {
        navigate("/register-contact-details");
      } else navigate("/current-orders");
    } else {
      navigate("/email-verification-send");
    }
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const onError = (err) => {
    setSubmitDisable(false);
    formRef?.current?.setFieldError("email", err?.data?.errors?.email);
    formRef?.current?.setFieldError("password", err?.data?.errors?.password);
    setShowErrorPopup(true)
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleChange1 = (e) => {
    if (e.target.value.length > 0) {
      setPasswordDisable(true);
    } else {
      setPasswordDisable(false);
    }
  };

  const FormEnableCheck = () => {
    const {
      values: { email, password },
    } = useFormikContext();
    useEffect(() => {
      if (email.trim() != "" && password.trim() != "") {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [email, password]);
    return null;
  };

  return (
    <div className="login-container fn_Nunito d-flex flex-column flex-lg-row justify-content-center pb-3 pb-lg-0 ">
      <div className="mt-4">
        <img
          src={asscentsLogo}
          alt="website logo"
          className="login-logo-image d-lg-none"
        />
      </div>
      <div className="left-view  d-flex flex-column justify-content-center">
        <img
          src={subLogo}
          alt="Asscents Website"
          className="login-img align-self-center"
        />
      </div>
      <div className="right-view justify-content-center d-flex flex-column mt-5 mt-lg-0">
        <div className="form-container align-self-center d-flex justify-content-around m-0 flex-column">
          <img
            src={asscentsLogo}
            alt="website logo"
            className="login-logo-image d-none d-lg-block"
          />
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
            innerRef={formRef}
          >
            <Form>
              <FormEnableCheck />
              <h1 className="fw_700 fs_22 text-center text-lg-start">
                Login in your account
              </h1>
              <div className="w-100 mt-3">
                <label className="w-100 mx-1 label-input">Email Address</label>
                <Field name={"email"}>
                  {({ field, meta }) => (
                    <input
                      {...field}
                      placeholder="Enter your email address"
                      id={"email"}
                      className={"w-100 input-field"}
                    />
                  )}
                </Field>
                <ErrorMsg name="email" />
              </div>
              <div className="w-100 mt-lg-0">
                <label className="w-100 mx-1 label-input">Password</label>
                <Field name={"password"}>
                  {({ field, meta }) => (
                    <div className="position-relative">
                      <input
                        {...field}
                        placeholder="Enter your password"
                        id={"password"}
                        type={passwordVisible ? "text" : "password"}
                        className={"w-100 input-field"}
                        onKeyUp={(e) => handleChange1(e)}
                      />
                      <img
                        className="login_password_eye__icon cursor_pointer"
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        src={
                          passwordDisable
                            ? passwordVisible
                              ? eyeOn
                              : eyeOff
                            : eyeDead
                        }
                        alt="show password or not"
                      />
                    </div>
                  )}
                </Field>
                <div className="d-flex justify-content-between">
                  <div className="m-0 p-0">
                    <ErrorMsg name="password" />
                  </div>
                  <div
                    onClick={() => navigate("/forgot-password")}
                    className="span-support cursor_pointer text-nowrap fw_500 fs_12 pe-2"
                  >
                    Forget Password ?
                  </div>
                </div>
              </div>
              <button
                className="login-button"
                type="submit"
                disabled={disable || submitDisable}
              >
                {submitDisable && <Spinner size="sm" />}
                Login
              </button>
              {/* <p className="support-element">
                Don't have an account ?
                <span
                  onClick={() => navigate("/signup")}
                  className="span-support ms-1 cursor_pointer"
                >
                  Signup
                </span>
              </p> */}
            </Form>
          </Formik>
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
